<template>
    <div>
        <modal :name="modal_name" class="final-modal approve-modal-bg note-modal cancellation-reject-popup-ui-fix" transition="nice-modal-fade">
            <div class="v-modal-content" style="border-radius: 15px;">
                <div class="v-modal-header justify-content-center" style="position: relative;">
                    <span class="v-modal-dialog-title v-modal-title">Reason for Approval</span>
                    <div style="position: absolute;right:12px;top:13px">
                        <span class="icon icon-close text-white pointer close-left" @click="hideConfirmApproval()"></span>
                    </div>
                </div>
                <div class="general-section pb-2 pl-4 pr-4" style="background: #fff !important;">
                    <div class="v-modal-body pt-0 pb-0">
                        <div class="d-form" style="overflow: initial !important;">
                            <div class="mb-7 mt-3">
                                <div class="text-center mb-2">
                                    <img class="w-12" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/info.svg">
                                    <h4 class="font-weight-bold digi-black mt-3">Alert!</h4>
                                    <p class="fw-500 mt-2 mb-3">Are You Sure You Want to Approve ?</p>
                                </div>
                                <div class="pb-2" style="background: white !important;">
                                    <textarea class="form-control text-area" v-model="approval_data.action.comment" maxlength="1000" placeholder="Enter Approval notes" />
                                    <div class="float-right fs-10 mt-1">({{1000 - approval_data.action.comment.length}} / 1000)</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="v-modal-dialog-actions bg-white pt-0">
                    <div class="d-flex justify-content-center align-items-center my-3">
                        <button class="btn-secondary-outline text-capitalize mr-5 pointer w-150px" @click="hideConfirmApproval">Cancel</button>
                        <button class="btn btn-secondary text-capitalize pointer w-150px" :class="{'text-align-left' : isUploadingInProgress}" @click="confirmApprove" :disabled="isUploadingInProgress">
                            Confirm
                            <half-circle-spinner v-if='isUploadingInProgress' :animation-duration="1000" :size="20" color="#00448b" style="margin: 0 auto;top:-30px;left:30px" />
                        </button>
                    </div>
                </div>
            </div>
        </modal>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal> 
    </div>
</template>        
<script>
import { HalfCircleSpinner } from "epic-spinners";
import { SweetModal } from 'sweet-modal-vue';
// import expense from '@/components/mixins/expense';
import ticket from '../mixins/ticket';
// import {EventBus } from '../../eventBus/nav-bar-event.js';
export default {
    props: ['modal_name', 'approval_data'],
    mixins: [ticket],
    data(){
        return {
            signature: false,
            success_msg: '',
            warning_msg: '',
            isUploadingInProgress: false
        }
    },
    components:{
        SweetModal,
        HalfCircleSpinner
    },
    methods:{
        hideConfirmApproval(){
            // EventBus.$emit('ZindexChangeEnd')
            this.approval_data.action.comment = ""
            this.isUploadingInProgress =false
            this.$modal.hide(this.modal_name);
            this.$emit("hideApprove");
        },
        hideConfirmApprovalSaved(){
            this.approval_data.action.comment = ""
            this.isUploadingInProgress =false
            this.$modal.hide(this.modal_name);
            this.$emit("hideApproveSaved");
        },
        confirmApprove(){
            this.$validator.validateAll().then(result => {
                if (result == true) {
                    this.isUploadingInProgress = true
                    let payload = this.approval_data
                    this.ApproveTicketPart(payload).then(response => {
                        if(response.status_id == 1){
                            this.success_msg = "Ticket Approved Successfully"
                            this.$refs.success_modal.open();
                            setTimeout(() => {
                                this.isUploadingInProgress = false
                                this.$refs.success_modal.close();
                                this.hideConfirmApprovalSaved();
                            }, 3000);
                        } else {
                            this.warning_msg = response.reason
                            this.$refs.warning_modal.open();
                            setTimeout(() => {
                                this.isUploadingInProgress = false
                                this.$refs.warning_modal.close();
                            }, 3000);
                        }
                    }).catch(err => {
                        this.isUploadingInProgress = false
                        if(err.hasOwnProperty('reason')){
                            this.warning_msg = err.reason;
                        } else {
                            this.warning_msg = err;
                        }
                        this.$refs.warning_modal.open();
                        setTimeout(() => this.$refs.warning_modal.close(), 2000);
                    })
                }
            })        
        },
    }
}
</script>
<style scoped>
.text-area.form-control{
    height: 150px !important;
}
.text-area{
    border: none !important;
    border-radius: 5px !important;
    padding:5px !important;
    box-shadow: 0 1.5px 15px 0 rgba(0, 0, 0, 0.16) !important;
}
.w-12{
    width: 12%;
}
.digi-black{
    color: #303031;
}
.approve-modal-bg .v-modal-content {
    background-color: #d6e2ef !important;
}
.footer-approve-modal-bg{
    background-color: #d6e2ef !important;
}
.closeModal{
    background-color: #d6e2ef !important;
}
.v-modal-header{
    background-color: #f0ddb7 !important;
    padding: 10px 15px !important;
}
.btn-secondary-outline{
    color: #00448b !important;
    border: 1px solid #00448b !important;
    padding: 7px 20px;
    border-radius: 4px;
    background-color: #fff;;
}
.btn-secondary{
    color: #fff !important;
    /* border: 1px solid #00448b !important; */
    padding: 0px 5px !important;
    text-align: center;
    border-radius: 4px !important;
    background-color: #00448b;
}
.v-modal-dialog-title{
    text-transform: none !important;
}
.text-align-left{
    text-align: left !important;
}
</style>                    